import { initializeApp } from "https://www.gstatic.com/firebasejs/11.6.1/firebase-app.js";
import { getAuth, signInAnonymously, signInWithCustomToken } from "https://www.gstatic.com/firebasejs/11.6.1/firebase-auth.js";
import { getFirestore, collection, addDoc, query, onSnapshot, serverTimestamp, limit, orderBy } from "https://www.gstatic.com/firebasejs/11.6.1/firebase-firestore.js";

let db, auth;
let userId;

// 1. Robust ID Loading: Check the window object explicitly
const appId = (typeof window !== 'undefined' && window.__app_id) ? window.__app_id : 'lagoon-jump';

// 2. Robust Config Loading: Check window object for existing config, otherwise use fallback
const firebaseConfig = (typeof window !== 'undefined' && window.__firebase_config) 
    ? JSON.parse(window.__firebase_config) 
    : {
        apiKey: "AIzaSyA2232bN0iEFYmxAlgnL57zGQJejGXeqBM",
        authDomain: "lagoon-jump.firebaseapp.com",
        projectId: "lagoon-jump",
        storageBucket: "lagoon-jump.appspot.com",
        messagingSenderId: "936274419362",
        appId: "1:936274419362:web:2a3cacf3432dba6d4d81fb",
        measurementId: "G-BRQ1NP52QN"
    };

console.log("Initializing Firebase for App ID:", appId);

try {
    const app = initializeApp(firebaseConfig);
    db = getFirestore(app);
    auth = getAuth(app);
    
    if (typeof window !== 'undefined' && window.__initial_auth_token) {
        try {
            await signInWithCustomToken(auth, window.__initial_auth_token);
        } catch (customTokenError) {
            console.error("Custom token sign-in failed, using anonymous:", customTokenError);
            await signInAnonymously(auth);
        }
    } else {
        await signInAnonymously(auth);
    }
    userId = auth.currentUser.uid;
    
    initializeLeaderboard();

} catch (error) {
    console.error("Firebase Initialization Error:", error);
}

function initializeLeaderboard() {
    const leaderboardCollectionPath = `artifacts/${appId}/public/data/leaderboard`;
    console.log("Listening to path:", leaderboardCollectionPath);

    // Note: If this query requires an index, it will log a link to the console to create it.
    const q = query(collection(db, leaderboardCollectionPath), orderBy('score', 'desc'), limit(50));
    
    onSnapshot(q, (snapshot) => {
        const leaderboardLists = document.querySelectorAll('.leaderboard-list-target');
        
        if (snapshot.empty) {
            console.log("No scores found in database.");
            // Optional: Add a placeholder if empty
            leaderboardLists.forEach(list => {
                list.innerHTML = '<li class="text-gray-400 text-sm italic p-2">No scores yet. Be the first!</li>';
            });
            // Still show the container
            const display = document.getElementById('leaderboard-display');
            if(display) display.classList.remove('hidden');
            return;
        }

        const highScores = new Map();

        snapshot.forEach(doc => {
            const data = doc.data();
            const name = data.name || "Anonymous";
            const score = data.score || 0;
            
            // Only keep the highest score per player name
            if (!highScores.has(name) || score > highScores.get(name).score) {
                highScores.set(name, { name, score });
            }
        });
        
        const uniqueTopScores = Array.from(highScores.values())
            .sort((a, b) => b.score - a.score)
            .slice(0, 5);

        // Update DOM
        leaderboardLists.forEach(list => {
            list.innerHTML = ''; 
            uniqueTopScores.forEach(data => {
                const li = document.createElement('li');
                li.textContent = `${data.name}: ${data.score}`;
                li.className = 'truncate py-1 border-b border-gray-700 last:border-0';
                list.appendChild(li);
            });
        });

        const display = document.getElementById('leaderboard-display');
        if(display) display.classList.remove('hidden');
        
    }, (error) => {
        console.error("Leaderboard Error. You may need to create a Firestore Index.", error);
    });
}

async function saveScore(name, score) {
    const finalScore = Math.floor(score);
    if (!name || isNaN(finalScore) || !db) return;
    try {
        const leaderboardCollectionPath = `artifacts/${appId}/public/data/leaderboard`;
        await addDoc(collection(db, leaderboardCollectionPath), {
            name: name,
            score: finalScore,
            userId: userId,
            timestamp: serverTimestamp()
        });
        console.log("Score saved successfully!");
    } catch (error) {
        console.error("Error writing document: ", error);
    }
}

window.saveScore = saveScore;